import React from 'react';
import PropTypes from 'prop-types';
import TitleRow from './TitleRow';
import TransactionVolume from './TransactionVolume';
import RecruitingActivity from './RecruitingActivity';
import AgentProductivity from './AgentProductivity';
import SupplyAndDemand from './SupplyAndDemand';

const Dashboard = (props) => {
    if (!props?.userInfo) return null;

    return (
        <>
            <TitleRow {...props} />
            <div className="p-4">
                <div className="dashboard row">
                    <div className="col-lg-4">
                        <div className="h-100">
                            <RecruitingActivity />
                        </div>
                    </div>
                    <div className="col-lg-8">
                        <div className="row mb-4">
                            <div className="col-md-6 mb-4 mb-md-0">
                                <AgentProductivity />
                            </div>
                            <div className="col-md-6">
                                <SupplyAndDemand />
                            </div>
                        </div>
                        <div className="row">
                            <div className="col-12">
                                <TransactionVolume />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
};

Dashboard.propTypes = {
    userInfo: PropTypes.object
};

export default Dashboard;
